<button
  class="btn-orderby"
  [class.active]="orderBy() === orderByKey()"
  [class.upside-down]="orderBy() === orderByKey() && direction() === 'ASC'"
  (click)="toggleOrder()"
>
  <i class="material-icons">keyboard_arrow_down</i>
</button>
